export default __webpack_public_path__ + "static/media/1962.97ddb115.png";